import React, { Component } from 'react';
import AppButton from './AppButton';
import { Address } from './Address'
import AuthService from "../services/AuthService";
import './AdditionalOptions.scss';

export class AdditionalOptions extends Component {
    static displayName = AdditionalOptions.name;

    constructor(props) {
        super(props);
        const { match: { params } } = this.props;
        this.state = {
            notFound: false,
            shipment: {
                connote: "",
                from: {},
                to: {}
            },
            offer: {
                offers: [{}]                
            },
            params: params || {jobid: null},
            busy: true
        };
    }

    async componentDidMount() {   
        this.authService = await AuthService.getInstance();             
        await this.loadOffer();
        await this.loadServices();        
    }

    loadServices = async () => {
        //console.log('Loading Services...');
        var services = this.state.shipment.additionalServices;
        //console.log('Additional services', services, services.length);
        this.setState({shipment: {...this.state.shipment, additionalServices: services}});        
    }

    async loadOffer() {
        let offer;
        if(this.state.params.jobid === "testing") 
            offer = {shipment: {
                connote: "TESTING",
                status: "DriverNear",
                from: { line1: "Fliway Internal Billing" },
                to: { line1: "Quentin Bennett", line2: "77 Westney Road", line3: "Mangere"}
            },
            offer: {
                offers: [{start_time: new Date()}],
                status: "Accepted"            
            }
        };        
        else
            offer = await (await window.fetch('api/offer/' + this.state.params.jobid)).json();
        this.setOffer(offer);
        this.setState({busy: false});
        return offer;
    }

    setOffer(newOffer) {
        //console.log('offer details', newOffer);
        if (newOffer.location){
            this.setState({location: newOffer.location});
        }
        if (newOffer.shipment){
            this.setState({shipment: newOffer.shipment});
        }
        if (newOffer.offer){
            this.setState({offer: newOffer.offer});
        }
        else if (newOffer.status === 404) {
            this.setState({
                notFound: true
            });
        }
    }

    postData(url = '', data = {}, accessToken = null) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if(accessToken)
            headers.append('Authorization', `Bearer ${accessToken}`);

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: headers,
            redirect: 'follow',
            referrer: 'no-referrer',
            body: JSON.stringify(data),
        })
        .then(response => {
            if(!response.ok) {
                if(response.status == "409"){
                    alert("Sorry this is out of date; Tap to refresh.");
                    return this.loadOffer();
                }
                if(response.status == "401"){
                    alert("Please login or register to do this.");
                    return null;
                }
                else{
                    alert("Error: " + response.statusText);
                }
            }
            return response.json();
        });
    }

    async startRedirect() {
        //check if we're logged in
        try{
            var user = await this.authService.getAuthenticatedUser(true);
            if(user)
                this.props.history.push('../../rd/' + this.state.params.jobid)
        }        
        catch(err) {
            console.error(err);
            return;
        }        
    }

    render() {
        return (
            this.state.notFound === true ?
            <div>
                <div className="header">My Delivery: NOT FOUND</div>
                <div style={{textAlign: "center"}}>Shipment Not Found</div>
            </div> :
            <div>
                <div className="header">My Delivery: ADDITIONAL OPTIONS</div>
                {this.state.busy && <div>Loading...</div>}
                {!this.state.busy &&
                <div className="view-body">   
                    <div className="edit-icon-right">
                        <Address label="We have a parcel for you from" address={{line1: this.state.shipment.from.line1}} />
                        <div><i className="icon-x-app-icon connote"></i></div>
                    </div>                                        
                    <Address label="Your delivery address" address={this.state.shipment.to} />                    
                    <div>
                        <label>Consignment Number</label>
                        <div className="fakeinput">
                            {this.state.shipment.connote}
                        </div>
                    </div>
                    <div className="action-area">
                        <div className="clearfix">
                            { this.state.shipment.allow_redirect === true &&
                            <AppButton iconName="icon-button-change-address" onClick={() => this.startRedirect()} 
                                actionText="Change Delivery Address" footer="Deliver elsewhere. Additional charges may apply"/>}
                            { (this.state.shipment.additionalServices && this.state.shipment.additionalServices.length > 0) && 
                            <AppButton iconName="icon-button-timer" onClick={() => { this.props.history.push('../../as/' + this.state.params.jobid)  }} 
                                actionText="Additional Services" footer="Tap for additional services"/>}
                            <AppButton function iconName="icon-function-left-arrow-up" actionText="Back" 
                                onClick={() => { this.props.history.push('../../o/' + this.state.params.jobid)  }} footer="Return to details"/>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}
